import { put, all, call, takeEvery, select } from "redux-saga/effects";
import { paragraphsReducerConstants, paragraphsReducerActions } from "../actions";
import { getChapterParas } from "@/shared/store/saga-functions";
import { _sharedActionsSystem } from "@/shared/store/system/actions";
import { makeLoaderIdChapterParasLoading } from "@/shared/store/paragraphs/constants";
import { selectorLoaderById } from "@/shared/store/system/selectors";
import { getBookIdWithPrefix } from "@/shared/utils/content/content";
import {BooksIdsJTL} from "@/shared/utils/reader/constants";

function* fetchChapterParasWorker(action) {
  const { chapterId, highlight, onResponseNotIncludesRequestedChapterId } = action.data;

  const loaderId = makeLoaderIdChapterParasLoading(chapterId);
  const isLoading = yield select((s) => selectorLoaderById(s, loaderId));

  if (isLoading) {
    return;
  }

  try {
    yield put(_sharedActionsSystem.loading(loaderId, false, true));

    const content = yield getChapterParas(
      chapterId,
      highlight,
      BooksIdsJTL.includes(getBookIdWithPrefix(chapterId)),
    );
    if (content) {
      const indexChapterIdInResponse = content.paras.findIndex((p) => p.para_id === chapterId);

      const chapterIdActual = indexChapterIdInResponse === 0
        // If to make a request with an id of a random chapter's para,
        // actual {chapterId} will be the first para's id.
        ? chapterId
        : content.paras[0].para_id;

      if (indexChapterIdInResponse === -1 && onResponseNotIncludesRequestedChapterId) {
        yield call(onResponseNotIncludesRequestedChapterId, { chapterIdActual });
      }

      yield put(paragraphsReducerActions.fetchChapterParasSuccess(
        chapterIdActual, content.paras, content.highlight
      ));
    }
  } finally {
    yield put(_sharedActionsSystem.loading(loaderId, true));
  }
}

export default function* systemSaga() {
  yield all([takeEvery(paragraphsReducerConstants.FETCH_CHAPTER_PARAS, fetchChapterParasWorker)]);
}
